import request from '@aned/request';

// v2查询装载率详情
export async function search_dayv2(params) {
  return request('/api/route/loadingRatio/v2/selectLoadRatio', {
    method: 'POST',
    body: params,
    reqType: 'json',
    // module: 'route',
  });
}

// v2查询合计
export async function aggregatev2(params) {
  return request('/api/route/loadingRatio/v2/selectLoadRatio/agg', {
    method: 'POST',
    body: params,
    reqType: 'json',
    // module: 'route',
  });
}
// v2导出
export async function search_day_exportv2(params) {
  return request('/api/route/loadingRatio/v2/selectLoadRatio/export', {
    method: 'POST',
    body: params,
    reqType: 'json',
    // module: 'route',
  });
}

// 获取类区分类(树形数据)
export async function getClassAreaNameTreeTreeList(params) {
  return request('/api/classifyNew/getClassAreaNameNewList', {
    method: 'POST',
    body: params,
    module: 'basic',
    reqType: 'json',
  });
}
